import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { GetMenuJsonService } from '@app/core/services/get-menu-json.service';
import { createViewContainerData } from '@angular/core/src/view/refs';
import { PermissionService } from '@app/config/app-permission.service';
import { routes } from '../main-dashboard/main-dashboard.routing';
import { LoginToken } from '@app/base/model/local-storage.model';

@Component({
    selector: 'app-menu-pelizza',
    templateUrl: './menu-pelizza.component.html',
    styleUrls: ['./menu-pelizza.component.css']
})

export class MenuPelizzaComponent implements OnInit {

    @Input() menuTheos: any;
    @Input() bigIconWidth: any;
    @Output() respostaMenu = new EventEmitter();
    public tabs: NodeList = document.querySelectorAll('ul.abas li');
    public section_tab: NodeList = document.querySelectorAll('section.section_aba');
    public initialScreen: number = window.innerWidth;
    public cssStyle;
    private privateFlag: number = -1;
	public isAdmTheos: string;

    public atualRoute =  this.router.config[0].children[1].path.charAt(0).toUpperCase() + this.router.config[0].children[1].path.substr(1) ;
	public isNewExperience = JSON.parse(window.localStorage.getItem('isNewExperience'));
	public localStorageIsMitra =
    JSON.parse(window.localStorage.getItem('loginToken'))[
      'IsAdmTheos'
    ] === 'true' ? true : false;

    constructor(
        public permissionService: PermissionService,
        private service: GetMenuJsonService,
        private route: ActivatedRoute,
        private router: Router,
    ) { 
		console.log(this.localStorageIsMitra)
	}

    openSubdropdown($event) {
        $event.stopPropagation();
        Array.from($event.target.nextSibling.classList).forEach(function(c) {
            if (c === 'show') {
                $event.target.nextSibling.classList.remove('show');
            } else {
                [].forEach.call(document.querySelectorAll('.sub-dropdown'), function(el) {
                    el.classList.remove('show');
                });
                $event.target.nextSibling.classList.add('show');
            }
        });
    }

	// getDadosToken() {
	// 	var token = <LoginToken>JSON.parse(localStorage.getItem('loginToken'));
	// 	this.isAdmTheos = token.isAdmTheos.toString();
	// }

	hasProp(obj, name: 'isAdmTheos') {
		// console.log(obj.hasOwnProperty(name));
		return obj.hasOwnProperty(name);
	}

	canShow(obj): boolean {
		let objIsAdmTheos = obj.isAdmTheos;
		let usrIsAdmTheos = JSON.parse(this.isAdmTheos);
	
		return !objIsAdmTheos || (objIsAdmTheos && usrIsAdmTheos);
	  }
	

    ev(flag: any): void {
        if (flag !== this.privateFlag) {
            this.privateFlag = flag;
            this.init();
        }
    }

    removeClass(classe: string, ...elements: NodeList[]): void {
        elements.forEach((el) => {
            [].forEach.call(el, (e) => {
                e.classList.remove(classe);
            });
        });
    }

    addClass(classe: string, indice: number, ...elements: NodeList[]): void {
        [].forEach.call(elements, (el) => {
            (indice == null) ? el.forEach((e) => e.classList.add(classe)) : el.item(indice).classList.add(classe);
        });
    }

    menuMobile(): void {
        let menuAbas: NodeList = document.querySelectorAll('.menu-theos section.section_aba .subgroup .links');
        let subNameAction: NodeList = document.querySelectorAll('.menu-theos section.section_aba .subgroup .sub_name');
    }

    removeListener(): void {
        let menuOptions: NodeList = document.querySelectorAll('.menu-theos section.section_aba .subgroup .links');
        let subNameAction: NodeList = document.querySelectorAll('.menu-theos section.section_aba .subgroup .sub_name');

        this.removeClass('invisivel', menuOptions);

        [].forEach.call(subNameAction, (el) => {
            el.removeEventListener('click', this.menuMobile);
        });
    }

    init(): void {
        (this.initialScreen <= 600) ? this.menuMobile() : this.removeListener();
        window.addEventListener('resize', () => {
            let x: number = window.innerWidth;
            (x <= 600) ? this.menuMobile() : this.removeListener();
        });

        let links = document.querySelectorAll('.links');
        [].forEach.call(links, (el) => {
            if (el.getElementsByTagName('a').length === 0) {
                el.parentNode.remove();
            }
        });
    }

    changeTab(evt: any, i: number): void {
        let tabs: NodeList = document.querySelectorAll('ul.abas li');
        let section_tab: NodeList = document.querySelectorAll('section.section_aba');

        //abas do menu soh funcionam caso nao seja mobile
        let x: number = window.innerWidth;
        if (x > 600) {
            [].forEach.call(tabs, (el) => el.classList.remove('selected'));
            [].forEach.call(section_tab, (el) => el.classList.remove('selected'));
            evt.target.parentNode.classList.add('selected');
            document.querySelectorAll('section.section_aba')[i].classList.add('selected');
        }
    }

    changeCSSProperty(obj): void {
        for (let prop in obj) {
            document.documentElement.style.setProperty(prop, obj[prop]);
        }
    }

    async ngOnInit() {
        try {
            this.menuTheos = await this.service.getData('assets/menu-tribunal.json');
            this.cssStyle = this.menuTheos.config;
            this.respostaMenu.emit(this.menuTheos);
            this.changeCSSProperty(this.cssStyle);
        } catch (error) {
            throw new Error(error);
        }
    }

}
